var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs-items',{staticClass:"tab-items",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_vm._l((_vm.scopedSlots()),function(field){return _c('v-tab-item',{key:field,attrs:{"value":`${field}`}},[_vm._t(field)],2)}),_vm._t("customDashbord")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }